import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import SurveyQuizQuestions from "@/components/quiz/SurveyQuizQuestions.vue";
let SurveyQuiz = class SurveyQuiz extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "quiz", void 0);
    _defineProperty(this, "quizResult", void 0);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "realtimeUserAnswers", null);
  }
  mounted() {
    this.realtimeUserAnswers = this.quizResult;
    if (this.quiz && !this.realtimeUserAnswers) {
      this.realtimeUserAnswers = this.initRealtimeUserAnswers(this.quiz);
    }
  }
  get realtimeUserQuestions() {
    return this.realtimeUserAnswers?.questions || [];
  }
  initRealtimeUserAnswers(quiz) {
    return {
      contenuQuizId: quiz.id,
      questions: quiz.questions?.map(question => ({
        questionId: question.id,
        questionType: question.type,
        order: question.order,
        blanksText: question.blanksText,
        responsesIds: [],
        responseContent: ''
      })) || []
    };
  }
  emitQuizAnswers() {
    return this.realtimeUserAnswers;
  }
};
__decorate([Prop({
  required: true
})], SurveyQuiz.prototype, "quiz", void 0);
__decorate([Prop({
  default: null
})], SurveyQuiz.prototype, "quizResult", void 0);
__decorate([Prop({
  default: false
})], SurveyQuiz.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: false
})], SurveyQuiz.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], SurveyQuiz.prototype, "canEdit", void 0);
__decorate([Emit('answerChange')], SurveyQuiz.prototype, "emitQuizAnswers", null);
SurveyQuiz = __decorate([Component({
  components: {
    SurveyQuizQuestions,
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], SurveyQuiz);
export default SurveyQuiz;